export default __webpack_public_path__ + "static/media/group_2.d3304a1d.jpg";